// import ar from "./data/states/ar";
// import mx from "./data/states/mx";
// import br from "./data/states/br";
// import co from "./data/states/co";
// import uy from "./data/states/uy";
// import ec from "./data/states/ec";
// import py from "./data/states/py";
// import pe from "./data/states/pe";
// import cl from "./data/states/cl";
// import gt from "./data/states/gt";

// export function getCountryCenter(country) {
//   return MAP_CENTERS[country];
// }

// // export function getStatesByCountry(availableCountries, country) {
// //   debugger;
// //   return Object.values(availableCountries[country]?.level1Centers);
// // }

// export function getStateCenter(country, stateId) {
//   return getLevel1Center(country, stateId);
// }

// export function getLevel1Center(country, level1Id) {
//   return MAP_CENTERS[country].level1Centers[level1Id];
// }

// export function getDefaultLevel1ForCountry(countryData) {
//   return countryData.level1Centers[0][0];
// }

// export function level1IdExists(country, id) {
//   return !!MAP_CENTERS[country].level1Centers[id];
// }

// export function getLevel0Name(country) {
//   return MAP_CENTERS[country]?.name;
// }

// export function getLevel1Name(country, level1Id) {
//   return (
//     MAP_CENTERS[country]?.level1Centers[level1Id]?.name || level1Id.toString()
//   );
// }

// export function stateExists(country, stateId) {
//   return !!MAP_CENTERS[country]?.level1Centers[stateId];
// }

// export function countryExists(country) {
//   return !!MAP_CENTERS[country];
// }

// let MAP_CENTERS;

// if (process.env.NODE_ENV === "development" && process.env.REACT_APP_USE_LOCAL_DATA) {

//   MAP_CENTERS = {
//     [br.id]: br,
//     // [ar.id]: ar,
//     // [uy.id]: uy,
//     // [cl.id]: cl,
//     // [ec.id]: ec,
//     // [py.id]: py,
//     // [pe.id]: pe,
//     // [cl.id]: cl
//     // [ch.id]:
//     // ch: {
//     //   name: "Chile",
//     //   center: [-70.676564, -33.474764],
//     //   zoom: 4,
//     // },
//   };

// } else {

//   MAP_CENTERS = {
//     [ar.id]: ar,
//     [uy.id]: uy,
//     [co.id]: co,
//     [br.id]: br,
//     [mx.id]: mx,
//     [ec.id]: ec,
//     [py.id]: py,
//     [pe.id]: pe,
//     [cl.id]: cl,
//     [gt.id]: gt
//     // [ch.id]:
//     // ch: {
//     //   name: "Chile",
//     //   center: [-70.676564, -33.474764],
//     //   zoom: 4,
//     // },
//   };
// }


// // console.log("MAP CENTER: ", MAP_CENTERS);
// export function getCountriesData() {
//   return Object.values(MAP_CENTERS);
// }

const countryColors = {
  "ar": "#75AADB",
  "br": "#009C3B",
  "cl": "#FF0000",
  "co": "#FBBC05",
  "ec": "#FF6347",
  "gt": "#b1dae7",
  "mx": "#CE1126",
  "pe": "green",
  "py": "blue",
  "uy": "#0038A8"
}
export function getCountryColor(countryId) {
  return countryColors[countryId] || "black";
}

export { countryColors };